import React from 'react';
import { connect } from 'react-redux';
import { components, elements } from '@peachjar/components';
import ReviewSchools from './ReviewSchoolsTab';
import WebsiteButtonRequest from './WebsiteButtonRequestTab';
import {
  setTabViewSetupSchool,
  sendVerifiedSchools,
  toggleSchoolSelectionError,
} from '../setup-school.duck';

const { Tabber } = components;
const { typography } = elements;
const { Headline1 } = typography;

export const generateTabs = (
  areSchoolsActivated,
  numberOfSchools,
  verifiedSchools,
  handleContinueTabClick,
  tabViewSetupSchool,
  handleTabView,
  schoolSelectionError
) => {
  const onClickHandlerEnabled =
    (numberOfSchools === verifiedSchools.length &&
      !areSchoolsActivated &&
      !schoolSelectionError) ||
    areSchoolsActivated;
  const isLockedTrue =
    (verifiedSchools.length <= 0 && !areSchoolsActivated) ||
    schoolSelectionError;

  const tabs = [
    {
      id: 1,
      isActive: tabViewSetupSchool === 1,
      icon: 'Desktop',
      label: 'Review the information',
      labelSubText: 'we got from the NCES database. Uncheck the schools / sites that won’t use Peachjar.',
      onClickHandler: () => handleTabView(1),
      isLocked: false,
    },
    {
      id: 2,
      isActive: tabViewSetupSchool === 2,
      icon: 'Email',
      label: 'Send request',
      labelSubText: "to connect Peachjar flyers to each school's website.",
      onClickHandler: onClickHandlerEnabled
        ? () => handleContinueTabClick()
        : null,
      isLocked: isLockedTrue,
    },
  ];
  return tabs;
};

const SetupSchoolContainer = ({
  areSchoolsActivated,
  ncesDistrictId,
  numberOfSchools,
  registrant,
  contactPhoneNumber,
  verifiedSchools,
  handleContinueTabClick,
  tabViewSetupSchool,
  handleTabView,
  isSiteLinked,
  handleSchoolSelectionError,
  schoolSelectionError,
}) => (
  <React.Fragment>
    <Headline1 style={{ margin: '1rem 0' }}>Schools / Sites Setup</Headline1>
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
      }}
    >
      <Tabber
        tabs={generateTabs(
          areSchoolsActivated,
          numberOfSchools,
          verifiedSchools,
          handleContinueTabClick,
          tabViewSetupSchool,
          handleTabView,
          schoolSelectionError
        )}
      />
    </div>
    <div>
      {tabViewSetupSchool === 1 && (
        <ReviewSchools
          ncesDistrictId={ncesDistrictId}
          numberOfSchools={numberOfSchools}
          areSchoolsActivated={areSchoolsActivated}
          handleSchoolSelectionError={handleSchoolSelectionError}
        />
      )}
      {tabViewSetupSchool === 2 && (
        <WebsiteButtonRequest
          ncesDistrictId={ncesDistrictId}
          registrant={registrant}
          contactPhoneNumber={contactPhoneNumber}
          isSiteLinked={isSiteLinked}
        />
      )}
    </div>
  </React.Fragment>
);

const mapStateToProps = state => ({
  tabViewSetupSchool: state.setupSchool.tabViewSetupSchool,
  schoolSelectionError: state.setupSchool.schoolSelectionError,
});

const mapDispatchToProps = dispatch => ({
  handleContinueTabClick: () => {
    dispatch(sendVerifiedSchools());
    dispatch(setTabViewSetupSchool(2));
  },
  handleTabView: tab => {
    dispatch(setTabViewSetupSchool(tab));
  },
  handleSchoolSelectionError: boolean => {
    dispatch(toggleSchoolSelectionError(boolean));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SetupSchoolContainer);



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/school/containers/SetupSchoolContainer.jsx